import { render, staticRenderFns } from "./ContinueModalBasket.vue?vue&type=template&id=77a31b64&scoped=true"
import script from "./ContinueModalBasket.vue?vue&type=script&lang=js"
export * from "./ContinueModalBasket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a31b64",
  null
  
)

export default component.exports